import {Component, Input, OnInit} from '@angular/core';
import {Order} from '../../../services/order';
import {Contact} from '../../../services/contact';
import {CONTACT_TYPES_IDS} from '../../../../config/constants-10-4';

@Component({
    selector: 'app-client-contact-info',
    templateUrl: './client-contact-info.component.html',
    styleUrls: ['./client-contact-info.component.scss']
})
export class ClientContactInfoComponent implements OnInit {

    @Input() order: Order;

    invoiceContact: Contact | null;

    constructor() {
    }

    ngOnInit(): void {
        this.invoiceContact = this.order.getContactWithTypeId(CONTACT_TYPES_IDS.INVOICE_ADDRESS);
    }
}
